import React from 'react';
import Header from '../components/Header';
import './BannerLanding.css';

/**
 * Пустая посадочная страница под баннеры Tourvisor.
 * Header + пустой main + SiteFooter (из App).
 */
const BannerLanding = () => (
  <>
    <Header />
    <main className="banner-landing" aria-hidden="true" />
  </>
);

export default BannerLanding;
